const t=new Set(["opacity","clipPath","filter","transform"]);export{t as acceleratedValues};
